<template>
  <div class="text-center">登陆中...</div>
</template>

<script>
  export default {
    metaInfo() {
      return {
        title: '管理员登陆',
      };
    },
    name: 'AdminLogin',
    mounted() {
      if (this.$route.name === 'admin-login') {
        const params = { code: this.$route.query.code };
        this.$store.dispatch('adminLogin', params).then(() => {
          this.$router.push({ name: 'home' });
        }).catch((e) => {
          if (e.response) {
            this.$notify({
              title: '登錄失敗',
              message: e.response.data.message,
              type: 'error',
            });
          }
        });
      }
    },
  };
</script>
